<template>
  <div class="home">
    <!-- indicator-position 指示器的位置 outside/none
            不写该属性，默认情况下在图片上
    -->

    <div class="core">
      <div class="main">
        <div class="main_top">
          <el-carousel
            height="510px"
            :interval="5000"
            :autoplay="true"
            arrow="never"
          >
            <el-carousel-item v-for="(item, index) in images" :key="index">
              <el-image :src="item.url"> </el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <!-- <div class="sanj"></div> -->
    <div class="subject">
      <div class="elective">
        <div>专业课程</div>
        <div>
          为学习无人机驾驶学员打造由简到难课程学习<span
            @click="toOnlineCourse()"
            style="cursor: pointer"
            >前往体验></span
          >
        </div>
      </div>
      <div class="subject_con">
        <div class="subject_recommend">
          <div class="play1" v-show="isplayhome == true">
            <img src="../image/playCircle.png" alt="" @click="playCirlhome()" />
          </div>

          <video
            src="http://app.youtixijiaoyu.com/education-h5/video/%E5%88%9D%E7%BA%A7/%E8%AE%A4%E8%AF%86%E6%97%A0%E4%BA%BA%E6%9C%BA.mp4"
            id="myVideo"
            muted="muted"
            loop
            controls
          ></video>
        </div>
        <div class="subjectFourBox">
          <div v-for="item in g_sub_coursList" class="subjetFour">
            <img
              :src="item.pic"
              alt=""
              class="subjectFourImg"
              @click="toCourse(item.videourl)"
            />
          </div>
          <!-- <Subject :simgList="g_sub_coursList" /> -->
        </div>
      </div>
    </div>
    <!-- 证书培训 -->
    <div class="subjectType">
      <div class="elective">
        <div>证书培训</div>
        <div>各种类型的课程 满足不同学员的需求</div>
      </div>
      <div class="group fivesubject">
        <div
          v-for="(item, index) in fivesubject"
          :key="index"
          class="certifate_name"
          @mouseenter="fivesubenter(index)"
        >
          <img
            :src="index == subindex ? item.activeimg : item.inactive"
            alt=""
          />
          <div :style="index == subindex ? 'color:#0585D7' : 'color:#333'">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div id="system">
      <div class="style">
        <div style="padding-top: 40px; padding-bottom: 53px">
          <div class="style_modul">
            <!--  :style="{ background: `url(${item.icon})` }" -->
            <div class="modul_list" v-for="item in style_list" :key="item.id">
              <div class="modul_con">
                <div style="dispaly: flex; align-items: center; height: 20px">
                  <span v-text="item.text"></span>
                </div>
                <p v-text="item.detai"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="type_group">
      <div class="group">
        <div class="group_one">
          <span class="yellowline"></span>
          <div class="groupnum">120+</div>
          <div class="groupnum">合作伙伴</div>
        </div>
        <div class="group_one">
          <span class="yellowline"></span>
          <div class="groupnum">10+</div>
          <div class="groupnum">专业讲师</div>
        </div>
        <div class="group_one">
          <span class="yellowline"></span>
          <div class="groupnum">30+</div>
          <div class="groupnum">课程学时</div>
        </div>
        <div class="group_one">
          <span class="yellowline"></span>
          <div class="groupnum">2000+</div>
          <div class="groupnum">累计学员</div>
        </div>
      </div>
    </div>
    <!-- 合作咨询 -->
    <div class="oprate" v-if="newshow">
      <div class="elective">
        <div>最新动态</div>
        <div>了解无人机最新资讯 见证无人机竞赛</div>
      </div>
      <div class="oprate_two">
        <img :src="competitionData[0].pic" alt="" class="newask_img" />
        <div class="newaskRight">
          <div>NEW</div>
          <div @click="homepage_info('/guidanceinfo', competitionData[0].id)">
            {{ competitionData[0].title }}
          </div>
          <div>
            {{ competitionData[0].subtitle }}
          </div>
          <div>
            <span>类型：竞赛指导</span>
            <span>日期：{{ competitionData[0].publishtime }}</span>
          </div>
        </div>
      </div>
      <div class="oprate_two">
        <div
          class="news1"
          v-for="item in newsData"
          @click="homepage_info('/newsinfo', item.id)"
        >
          <div class="news1child">
            <div class="news1Picimg">
              <img :src="item.pic" alt="" srcset="" />
            </div>
            
            <div class="news1child_con">
              <vue-clamp :max-lines="1" style="font-weight: bold">{{
                item.title
              }}</vue-clamp>
              <vue-clamp :max-lines="2" class="news1child_sub" autoresize>{{
                item.subtitle
              }}</vue-clamp>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <div class="partner">
      <div class="elective">
        <div>培训流程</div>
        <div>以学生为中心 以就业为导向 为社会提供人才</div>
      </div>
      <div class="peixunliucheng">
        <img src="../image/zu72.png" alt="" class="" />
        <div class="group peixunstep">
          <div>无人机法规<br />和安全学习</div>
          <div>无人机模拟<br />虚拟现实无人机</div>
          <div>无人机外业训练<br /></div>
          <div>智慧需求<br />和系统学习</div>
          <div>智慧需求外业培训</div>
          <div>理论和实践考试</div>
        </div>
      </div>
      <div class="group trainSteps">
        <div class="swiperTrain">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div><img src="../image/peixun1.png" alt="" /></div>
            </div>
            <div class="swiper-slide">
              <div><img src="../image/peixun2.png" alt="" /></div>
            </div>
            <div class="swiper-slide">
              <div><img src="../image/peixun3.png" alt="" /></div>
            </div>
            <div class="swiper-slide">
              <div><img src="../image/peixun4.png" alt="" /></div>
            </div>
          </div>
        </div>
        <div class="swiper-button-prev buttonPrev"></div>
        <div class="swiper-button-next buttonNext"></div>
      </div>
    </div>
    <!--  -->
    <div class="job">
      <div class="elective">
        <div>就业服务</div>
        <div>为每一位学员定制学习计划和就业服务</div>
      </div>
      <ul class="group findJoblc">
        <li>就业工作规划<br />标准化流程</li>
        <li>就业课程计划</li>
        <li>就业活动实施</li>
        <li>校区企业库的<br />搭建与维护</li>
        <li>学生评级方案</li>
        <li>学生就业<br />档案建立</li>
        <li>校区就业<br />保障与配合</li>
        <li>学生实习<br />就业流程</li>
        <li>就业手册制作</li>
      </ul>
      <ul class="job_four group">
        <li
          v-for="(item, index) in job"
          :key="index"
          :style="{
            background: 'url(' + item.bk + ') no-repeat center center',
          }"
          @mouseenter="hover(index)"
          :class="index == isActive ? 'active' : 'noactive'"
          class="jobli"
        >
          <!-- <img :src="item.url" alt="" class="index" /> -->
          <p class="job_tl job_tl1">{{ item.tl1 }}</p>
          <p class="job_tl job_tl2">{{ item.tl2 }}</p>
          <p class="more" v-show="index == isActive">{{ item.more }}</p>
        </li>
      </ul>
    </div>

    <FilePreview
      :showFilePreview="showFilePreview"
      :currentFile="currentFile"
      @close="close"
      v-if="showFilePreview"
    ></FilePreview>
  </div>
</template>

<script>
import $ from "jquery";
import "../css/index.css";
import FilePreview from "../components/FilePreview.vue";

import "swiper/dist/js/swiper";
import "swiper/dist/css/swiper.css";
import Swiper from "swiper";

export default {
  name: "Vue2TemplateHome",
  components: { FilePreview },
  data() {
    return {
      showFilePreview: false,
      currentFile: {
        fileUrl: "",
      },
      newshow: false,
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 30,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      images: [
        { id: 1, url: require("../image/swiper.jpg") },
        { id: 2, url: require("../image/swiper.jpg") },
      ],
      activeName: "first",

      g_sub_coursList: [],

      style_list: [
        {
          id: 1,
          text: "证书分级",
          detai:
            "AOPA无人机驾驶员合格证分为三个机型，分别是多旋翼、固定翼、直升机；三种机型又三种级别，分别是视距内驾驶员（驾驶员）、超视距驾驶员（机长）和教员。",
        },
        {
          id: 2,
          text: "行业应用",
          detai:
            "应用的行业比较广泛，是从事无人机行业人员必备的敲门砖，像植保无人机、电力巡检、航拍摄影、消防安全等多个行业都是用的aopa证，所以就业范围广泛，含金量高。",
        },
        {
          id: 3,
          text: "考核内容",
          detai:
            "理论+实践，每一个等级的考核内容是不同的，但是第一关都是笔试，笔试的内容都是气象、飞行过程紧急处理、无人机飞行事项、无人机操作、无人机原理、无人机法规等一些专业知识。",
        },
        {
          id: 4,
          text: "AOPA的用途",
          detai:
            "AOPA培训的是基础操控，是无人机训练合格证 。持有AOPA合格证，可以使用对应类别、级别的无人机进行商业飞行；可以作为向空军及航管部门申请飞行计划时的人员证照凭证。",
        },
      ],
      oprate_qiye_list: "",
      oprate_gaoxiao_list: "",

      isActive: 0,
      job: [
        {
          id: 1,

          tl1: "校外实习",
          tl2: "工学交替",
          more: "",
          bk: require("../image/squar1.jpg"),
        },
        {
          id: 2,

          tl1: "职业素养提升",
          tl2: "就业能力训练",
          more: "",
          bk: require("../image/squar2.jpg"),
        },
        {
          id: 3,

          tl1: "对口就业服务",
          tl2: "企业定向培养",
          more: "",
          bk: require("../image/squar3.jpg"),
        },
        {
          id: 4,

          tl1: "档案建立",
          tl2: "人才内推",
          more: "",
          bk: require("../image/squar4.jpg"),
        },
      ],
      // four: "",

      isplayhome: true,
      fivesubject: [
        {
          name: "AOPA课程",
          activeimg: require("../image/zhengshu1.png"),
          inactive: require("../image/zhengshu1-hui.png"),
        },
        {
          name: "UTC测绘课程",
          activeimg: require("../image/zhengshu2.png"),
          inactive: require("../image/zhengshu2-hui.png"),
        },
        {
          name: "UTC建模课程",
          activeimg: require("../image/zhengshu3.png"),
          inactive: require("../image/zhengshu3-hui.png"),
        },
        {
          name: "UTC航拍课程",
          activeimg: require("../image/zhengshu4.png"),
          inactive: require("../image/zhengshu4-hui.png"),
        },
        {
          name: "ASFC课程",
          activeimg: require("../image/zhengshu5.png"),
          inactive: require("../image/zhengshu5-hui.png"),
        },
      ],
      subindex: 0,
      competitionData: "",
      newsData: "",
    };
  },

  methods: {
    close() {
      this.showFilePreview = false;
    },
    fivesubenter(index) {
      this.subindex = index;
    },

    hover(index) {
      this.isActive = index;
    },
    //首页专业课程---前往体验跳转
    toOnlineCourse() {
      this.$store.commit("CHANGE_PAGE", "/onlinecourse");
      this.$router.push({ path: "/onlinecourse" });
    },
    getCompetition(layer, count, data) {
      this.$axios({
        methods: "get",
        url: `Data?uid=39&layer=${layer}&operation=query&start=1&count=${count}&orderfields=publishtime%2520desc&outfields=id,title,subtitle,publishtime,pic`,
      }).then((res) => {
        if (res.data.state) {
          this[data] = res.data.data;
          setTimeout(() => {
            this.newshow = true;
          }, 1000);
        }
      });
    },
    getCourseFour() {
      this.$axios({
        method: "get",
        url: "Data?uid=39&layer=courselist&operation=query&start=1&count=4&orderfields=publish_time%2520desc",
      }).then((res) => {
        if (res.data.size != 0) {
          this.g_sub_coursList = res.data.data;
        } else {
          this.g_sub_coursList = [
            {
              id: 1,
              pic: require("../image/wurenji1.jpg"),
              videourl: "",
            },
            {
              id: 2,
              pic: require("../image/wurenji2.jpg"),
              videourl: "",
            },
            {
              id: 3,
              pic: require("../image/wurenji3.jpg"),
              videourl: "",
            },
            {
              id: 4,
              pic: require("../image/wurenji5.jpg"),
              videourl: "",
            },
          ];
        }
      });
    },
    toCourse(obj) {
      if (obj) {
        console.log(obj);
        this.currentFile.fileUrl = obj;
        this.showFilePreview = true;
      }
    },
    homepage_info(path, id) {
      this.$router.push({
        path: path,
      });
      this.$store.commit("CHANGE_PAGE", path);
      this.$store.commit("ParamsId", id);
    },
    // 视频播放按钮
    playCirlhome() {
      var video1 = document.getElementById("myVideo");
      video1.play();
      this.isplayhome = false;
    },
  },
  created() {
    this.getCourseFour();
    this.getCompetition("competitioninfo", 1, "competitionData");
    this.getCompetition("newsinfo", 4, "newsData");
  },
  mounted() {
    const mySwiper = new Swiper(".swiperTrain", {
      loop: true,
      direction: "horizontal",
      slidesPerView: 4,
      // speed: 50,
      autoplay: { disableOnInteraction: false },
      on: {
        resize: function () {
          setTimeout(() => {
            mySwiper.update();
          }, 500); //延时器很重要，不加可能会出错
        },
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        1204: {
          direction: "horizontal",
          onlyExternal: false,
          pagination: ".swiper-pagination",
          paginationClickable: true,
        },
      },
    });

    // 监测是不是QQ浏览器，如果是去掉播放按钮图片
    var ua = navigator.userAgent.toLocaleLowerCase();
    if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
      this.isplayhome = false;
    }
    // 监听是不是IE浏览器如果是，改变top值
    setTimeout(() => {
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        var yellowline = $(".yellowline");
        for (let i = 0; i < 4; i++) {
          $(yellowline)[i].style.top = "9px";
        }
      }
    }, 100);
  },
};
</script>

<style lang="less" scoped>
video {
  height: 340px !important;
  object-fit: fill;
}
.peixunliucheng {
  width: 1200px;
  margin: 0 auto;
}
.fivesubject {
  padding: 40px 0;
  justify-content: space-around;
}

.fivesubject div {
  cursor: pointer;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}

.fivesubject div:hover {
  color: #0585d7;
}

.el-drawer__body {
  height: 60px;
  overflow: auto;
}

.el-carousel {
  width: 100%;
}

// .el-carousel__container {
//   height: 350px !important;
// }

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.el-image {
  width: 100%;
  height: 510px !important;
}

/deep/.el-carousel__indicators--horizontal {
  .el-carousel__indicator--horizontal button {
    width: 8px;
    height: 8px;
    background: #ffffff;
    border-radius: 50%;
    opacity: 1;
  }

  .el-carousel__indicator--horizontal.is-active button {
    width: 24px;
    height: 8px;
    background: #ffffff;
    opacity: 1;
    border-radius: 10px;
  }

  .el-carousel__container {
    height: auto !important;
  }

  .lx {
    width: 1200px;
    height: 48px;

    margin: 0 auto;
    display: flex;
    align-items: center;
  }

  .lx p {
    margin-right: 20px;
  }
}
</style>
